/** Regelversion 11: Demokratie unter Druck (Panel „Machtfragen“, Entscheidung beim Widerstand, Chronik). */
import { usePref } from '../../lib/pref';
import { useGame, useS } from '../../store/game';
import { Panel } from '../../components/ui';
import { Illu } from '../../components/Illu';
import { STEPS, CARD_TXT, CARD_OPTS, LEVELS, demOn, demS, demV, demLabel, resLabel, stepBlock } from '../../engine/dem11';
import { de, dateLabel } from '../../engine/util';

/** Zwei Balken: Zustand der Demokratie und Widerstand. */
export function DemMeters({ v, res }: { v: number; res: number }) {
  return (
    <div className="demmeters">
      <div><span className="label">Zustand der Demokratie</span><div className="dembar"><i style={{ width: `${v}%` }} className={v >= 75 ? 'ok' : v >= 50 ? 'warn' : 'bad'} /></div><span className="sub"><b className="num">{de(v, 0)}</b> von 100 · {demLabel(v)}</span></div>
      <div><span className="label">Widerstand</span><div className="dembar res">{LEVELS.map((l) => <em key={l} style={{ left: `${l}%` }} />)}<i style={{ width: `${res}%` }} /></div><span className="sub"><b className="num">{de(res, 0)}</b> von 100 · {resLabel(res)}</span></div>
    </div>
  );
}

/** Reiter „Lage“: Eingriffe in die Gewaltenteilung. */
export function MachtPanel() {
  const S = useS(); const { dispatch } = useGame();
  const [open, setOpen] = usePref('kabinett-macht-offen', false);
  if (!demOn()) return null;
  const D = demS(), v = demV(), res = D?.res ?? 0;
  const title = <button type="button" className="ptoggle" aria-expanded={open} onClick={() => setOpen(!open)}>Machtfragen</button>;
  if (!open) return <Panel title={title} aside={`Demokratie ${de(v, 0)} · eingeklappt`} className="macht closed"><span className="sub">Eingriffe in Gerichte, Medien und Wahlen. Das Spiel zeigt, wie Demokratien ausgehöhlt werden und was sich dagegen stemmt. <button type="button" className="linkb" onClick={() => setOpen(true)}>Aufklappen</button></span></Panel>;
  return (
    <Panel title={title} aside={demLabel(v)} className="macht">
      <DemMeters v={v} res={res} />
      <p className="sub">Jeder Eingriff bringt eurer Regierung einen Vorteil und kostet die Demokratie. Dagegen stehen Bundestag und Bundesrat, eure Koalitionspartner, Abweichler in der eigenen Fraktion, der Bundespräsident, Karlsruhe und die EU. Mit jedem Eingriff wächst der Widerstand im Land, bis zum Generalstreik und zum Sturz der Regierung. Partien mit einem Demokratiewert unter 50 bekommen keine Orden und stehen in einer eigenen Kategorie der Bestenliste.</p>
      <div className="demsteps">{STEPS.map((X) => { const done = D?.done[X.id] != null, why = done ? null : stepBlock(X.id); return (
        <div key={X.id} className={'demstep' + (done ? ' done' : '')}>
          <div className="oppact-h"><b>{X.n}</b><span className="num down">−{X.sev}</span></div>
          <span className="sub">{X.d}</span>
          <span className="sub">Wirkung: {X.eff}</span>
          {done ? <span className="tag down">umgesetzt {dateLabel(D!.done[X.id])}</span>
            : why ? <span className="sub warn">{why}</span>
            : <div><button type="button" className="small" onClick={() => dispatch('demStep' as any, X.id)}>{X.id === 'notstand' ? 'Notstand ausrufen' : 'Durchsetzen'}</button></div>}
        </div>); })}</div>
    </Panel>
  );
}

/** Entscheidung, wenn der Widerstand eine neue Stufe erreicht. */
export function DemCard() {
  const S = useS(); const { dispatch } = useGame(); const D = demS(); if (!D?.card) return null;
  const [t, d] = CARD_TXT[D.card.lvl];
  return (
    <div className="decision hotd"><Illu src="/img/moment/misstrauen.webp" className="illu card" /><span className="label">Widerstand · {dateLabel(S.m)}</span>
      <h3>{t}</h3><span className="sub">{d}</span>
      <DemMeters v={D.v} res={D.res} />
      <div className="copts">{CARD_OPTS.map(([l, x], i) => <button type="button" key={i} className="copt" onClick={() => dispatch('demCard' as any, i)}><b>{l}</b><span className="sub">{x}</span></button>)}</div></div>
  );
}

/** Chronik der Eingriffe und Gegenwehr (Endbildschirm). */
export function DemChronik() {
  const D = demS(); if (!D?.log.length) return null;
  return (
    <Panel title="Chronik">
      <div className="log">{D.log.map((l, i) => <div key={i}><span className="m">{dateLabel(l.m)}</span><span>{l.t}</span></div>)}</div>
    </Panel>
  );
}
